



























import Vue from 'vue'
import ItemsHorizontalList from '@/components/ItemsHorizontalList.vue'

export default Vue.extend({
  name: 'RecentItems',
  components: {
    ItemsHorizontalList,
  },
  props: {
    title: { type: String },
    objectNamePlural: { type: String },
    apiUrl: { type: String },
    nameFormat: {
      type: String,
      default: 'full',
    },
    viewAllUrl: {
      type: String,
      default: '/',
    },
  },
  mounted() {
    this.$api
      .get(this.apiUrl)
      .then((response) => (this.items = response.data['hydra:member']))
  },
  data: () => ({
    items: [],
  }),
})
